import React, { FunctionComponent } from 'react';
import { CommonDashboardReport } from "@home/components/CommonDashboardReport";

const IframeReport: FunctionComponent = (props: any) => 
  (<CommonDashboardReport
    {...props}
  />)
;

export default IframeReport;
